$(document).ready(function() {
    $('.js-client-logos-slider').slick({
        slidesToShow: 6,
        arrows: false,
        centerMode: true,
        autoplay: true, // Enable autoplay
        autoplaySpeed: 1500, // Set autoplay speed in milliseconds
        infinite: true, // Enable infinite looping
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 350,
                settings: {
                    centerMode: false,
                    slidesToShow: 1
                }
            }
        ]
    });
});